import { useRouter } from 'next/router';
import { useEffect } from 'react';
import Buyback from '@/components/buyback';
import settings from '@/settings';
import { samsungPhoneList, usedGalaxy } from '@/settings/configs/buyback/au';

export default function SellSamsung() {
  const bannerData = {
    heading: `SELL YOUR SAMSUNG GALAXY PHONE TODAY`,
    description: `Highest trade-in prices in ${settings.country} for Samsung Galaxy Phones.`,
  };
  const customSEOText = {
    title: `Sell your Used Samsung Galaxy Phone`,
    description: `Sell your used Samsung phones. You can sell Samsung Galaxy Fold, Samsung Galaxy S20, Samsung Galaxy S10, Samsung Galaxy S9, Samsung Galaxy Note 10, Samsung Galaxy Note 9, Samsung Galaxy A90, Samsung Galaxy A80, and many other Samsung Phones with Reebelo.`,
  };
  const router = useRouter();

  useEffect(() => {
    if (
      !settings.buyback_exist ||
      (settings.buyback_exist && settings.store === 'quista')
    )
      router.push('/buyback/sell-samsung-phone');
  }, [router]);

  return (
    <Buyback
      brand="Samsung Phones"
      brandShort="Samsung"
      bannerData={bannerData}
      title="Samsung Galaxy Phone"
      typeFormDevicesList={samsungPhoneList}
      customSEOText={customSEOText}
      priceTableList={usedGalaxy.map((val) => ({ title: val }))}
    />
  );
}
